import React from 'react'
import get from 'lodash/get'
import { Col, Modal, Button } from 'react-bootstrap'
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  LinkedinShareButton,
  FacebookIcon,
  EmailIcon,
  WhatsappIcon,
  TelegramIcon,
  LinkedinIcon,
  XIcon
} from 'react-share'

export default class SocialShareModal extends React.Component {
  render () {
    let disabledChannels = get(this.props, 'disabledChannels', {})
    return (
      <Modal show={this.props.show} bsSize='lg' dialogClassName={'modal-max'} onHide={this.props.hide}>
        <Modal.Header>
          <Modal.Title>Social Share</Modal.Title>
        </Modal.Header>
        <Modal.Body className={'modalBody'}>
          {!disabledChannels['facebook'] &&
          <Col sm={2} className={'colMargin hidden-xs'}>
            <FacebookShareButton quote={this.props.text} url={this.props.shareUrl}>
              <FacebookIcon size={48} round />
            </FacebookShareButton>
          </Col>
          }
          {!disabledChannels['twitter'] &&
          <Col sm={2} className={'colMargin hidden-xs'}>
            <TwitterShareButton title={this.props.text} url={this.props.shareUrl}>
              <XIcon size={48} round />
            </TwitterShareButton>
          </Col>
          }
          {!disabledChannels['email'] &&
          <Col sm={2} className={'colMargin hidden-xs'}>
            <EmailShareButton subject={this.props.title} body={this.props.text} url={this.props.shareUrl}>
              <EmailIcon size={48} round />
            </EmailShareButton>
          </Col>
          }
          {!disabledChannels['whatsapp'] &&
          <Col sm={2} className={'colMargin hidden-xs'}>
            <WhatsappShareButton title={this.props.text} url={this.props.shareUrl}>
              <WhatsappIcon size={48} round />
            </WhatsappShareButton>
          </Col>
          }
          {!disabledChannels['telegram'] &&
          <Col sm={2} className={'colMargin hidden-xs'}>
            <TelegramShareButton title={this.props.text} url={this.props.shareUrl}>
              <TelegramIcon size={48} round />
            </TelegramShareButton>
          </Col>
          }
          {!disabledChannels['linkedin'] &&
          <Col sm={2} className={'colMargin hidden-xs'}>
            <LinkedinShareButton title={this.props.text} url={this.props.shareUrl}>
              <LinkedinIcon size={48} round />
            </LinkedinShareButton>
          </Col>
          }

          {!disabledChannels['facebook'] &&
          <Col xs={4} className={'colMargin hidden-sm hidden-md hidden-lg'}>
            <FacebookShareButton quote={this.props.text} url={this.props.shareUrl}>
              <FacebookIcon size={48} round />
            </FacebookShareButton>
          </Col>
          }
          {!disabledChannels['twitter'] &&
          <Col xs={4} className={'colMargin hidden-sm hidden-md hidden-lg'}>
            <TwitterShareButton title={this.props.text} url={this.props.shareUrl}>
              <XIcon size={48} round />
            </TwitterShareButton>
          </Col>
          }
          {!disabledChannels['email'] &&
          <Col xs={4} className={'colMargin hidden-sm hidden-md hidden-lg'}>
            <EmailShareButton subject={this.props.title} body={this.props.text} url={this.props.shareUrl}>
              <EmailIcon size={48} round />
            </EmailShareButton>
          </Col>
          }
          {!disabledChannels['whatsapp'] &&
          <Col xs={4} className={'colMargin hidden-sm hidden-md hidden-lg'}>
            <WhatsappShareButton title={this.props.text} url={this.props.shareUrl}>
              <WhatsappIcon size={48} round />
            </WhatsappShareButton>
          </Col>
          }
          {!disabledChannels['telegram'] &&
          <Col xs={4} className={'colMargin hidden-sm hidden-md hidden-lg'}>
            <TelegramShareButton title={this.props.text} url={this.props.shareUrl}>
              <TelegramIcon size={48} round />
            </TelegramShareButton>
          </Col>
          }
          {!disabledChannels['linkedin'] &&
          <Col xs={4} className={'colMargin hidden-sm hidden-md hidden-lg'}>
            <LinkedinShareButton title={this.props.text} url={this.props.shareUrl}>
              <LinkedinIcon size={48} round />
            </LinkedinShareButton>
          </Col>
          }

        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={this.props.hide}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
